import React from "react";
import "../../day-plan-styles/ExpandedTaskCard.css";
import {
  PlanData,
  DailyTaskCard as DailyTaskCardType,
  HourlyTaskCard as HourlyTaskCardType,
  CustomTaskCard as CustomTaskCardType,
} from "../../../../types/types";
import DailyTaskCard from "./DailyTaskCard";
import HourlyTaskCard from "./HourlyTaskCard";
import CustomTaskCardComponent from "./CustomTaskCard";

interface ExpandedTaskCardProps {
  planData: PlanData;
  onToggle: () => void;
  isEditable: boolean;
  updateHour: string;
  currentStatus: string;
  dailyCard?: DailyTaskCardType;
  hourlyCard?: HourlyTaskCardType;
  customCard?: CustomTaskCardType;
  onValuesChange?: (available: number, produced: number) => void;
  onViewBreakdown?: (planData: PlanData) => void;
}

function ExpandedTaskCard({
  planData,
  onToggle,
  currentStatus,
  dailyCard,
  hourlyCard,
  customCard,
  onValuesChange,
  onViewBreakdown,
}: ExpandedTaskCardProps) {
  if (dailyCard) {
    return (
      <DailyTaskCard
        planData={planData}
        onToggle={onToggle}
        currentStatus={currentStatus}
        dailyCard={dailyCard}
        onValuesChange={onValuesChange}
        onViewBreakdown={onViewBreakdown}
      />
    );
  }
  if (customCard) {
    return (
      <CustomTaskCardComponent
        planData={planData}
        onToggle={onToggle}
        currentStatus={currentStatus}
        customCard={customCard}
        onValuesChange={onValuesChange}
        onViewBreakdown={onViewBreakdown}
      />
    );
  }
  if (hourlyCard) {
    return (
      <HourlyTaskCard
        planData={planData}
        onToggle={onToggle}
        currentStatus={currentStatus}
        hourlyCard={hourlyCard}
        onValuesChange={onValuesChange}
        onViewBreakdown={onViewBreakdown}
      />
    );
  }
  return null;
}

export default ExpandedTaskCard;
